import { component } from 'picoapp';
import { gsap } from 'gsap/all';

class Search {
  constructor(el, ctx) {
    this.isActive = false;
    this.ctx = ctx;
    this.identifier = el.dataset.identifier;
    this.isActive = false;
    this.init(el);
    this.initAnimations();
    this.bindEvents();
  }

  init(el) {
    this.wrapper = el;
    this.searchForm = el.querySelector('form');
  }

  initAnimations() {
    let tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.isActive = true;
        this.searchForm.querySelector('input')?.focus();
      },
      onReverseComplete: () => {
        this.isActive = false;
        gsap.set(this.el, { clearProps: 'all' });
      },
    });
    tl.set(this.wrapper, {display: 'block', immediateRender: false});
    tl.from(this.wrapper, { height:0, opacity: 0, stagger: 0.05, duration: 0.2, ease: 'power2.out' });
    tl.from(this.searchForm, { opacity: 0 });
    this.tl = tl;
  }

  bindEvents() {
    this.ctx.on('toggle', (state) => {
      if ( state.identifier == this.identifier) {
        if (this.isActive) {
          this.tl.reverse();
        } else {
          this.tl.play();
        }
      }
    });

    // Close modal with ESC key
    document.addEventListener('keyup', (e) => {
      if (e.key == 'Escape') {
        this.tl.reverse();
      }
    });
  }
}

// module.exports = Drawer;
export default component((node, ctx) => {
  new Search(node, ctx);
});